/**
 * Layer 2：记忆偏好弹窗业务逻辑
 */
import { useMemoizedFn } from 'ahooks';
import { useMemo } from 'react';
import { preprocessMarkdown } from '@/pages/aigc/pages/Agent/ChatPage/utils';
import { useLocalState } from '@/pages/aigc/pages/Agent/ChatPage/hooks/useLocalState';
import { useMemoryPreferences } from './useMemoryPreferences';

export interface IUseMemoryPreferencesModalReturn {
  isMemoryEnabled: boolean;
  hasMemory: boolean;
  formattedMemory: string;
  loading: boolean;
  handleToggleMemory: () => Promise<void>;
}

export const useMemoryPreferencesModal = (): IUseMemoryPreferencesModalReturn => {
  const { data, loading, setUseMemory } = useMemoryPreferences();
  const [localEnabled, setLocalEnabled] = useLocalState<boolean | undefined>(
    'memory_enabled',
    undefined,
  );
  // 接口未返回时默认 false，避免后端 false 导致开关从 true 闪烁到 false
  const isMemoryEnabled = localEnabled ?? data?.use_memory ?? false;

  const memoryContent = data?.memory?.trim() || '';
  const hasMemory = !!memoryContent;

  const formattedMemory = useMemo(
    () => (hasMemory ? preprocessMarkdown(memoryContent) : ''),
    [hasMemory, memoryContent],
  );

  const handleToggleMemory = useMemoizedFn(async (): Promise<void> => {
    const nextValue = !isMemoryEnabled;
    setLocalEnabled(nextValue);

    try {
      await setUseMemory(nextValue);
    } catch (error) {
      setLocalEnabled(!nextValue);
      console.error('切换记忆状态失败:', error);
    }
  });

  return {
    isMemoryEnabled,
    hasMemory,
    formattedMemory,
    loading,
    handleToggleMemory,
  };
};
